import { render, staticRenderFns } from "./BasePreloader.vue?vue&type=template&id=28d22ed3&scoped=true&"
import script from "./BasePreloader.vue?vue&type=script&lang=js&"
export * from "./BasePreloader.vue?vue&type=script&lang=js&"
import style0 from "./BasePreloader.vue?vue&type=style&index=0&id=28d22ed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d22ed3",
  null
  
)

export default component.exports